import {BaseImageUrl} from "../http/http";
import {isImageDom} from "./is";

export const getThumbImageUrl = (imageUrl:any) => {
    return  BaseImageUrl+imageUrl;
    if (!imageUrl) {
        return "";
    }
    const  images = imageUrl.split(".");
   if (images && images.length === 2) {
        return BaseImageUrl+images[0] + "_100x100"+ images[1];
    } else {
        return  BaseImageUrl+imageUrl;
    }
}

export const getImageUrlName = (imageUrl:string) => {
    if (!imageUrl) {
        return "";
    }
    const  images = imageUrl.split(".");
    if (images && images.length === 2) {
        return images[0];
    } else {
        return  "";
    }
}

export const getImageName = (imageUrl:string) => {
    if (!imageUrl) {
        return "";
    }
    const  images = imageUrl.split("\\");
    if (images && images.length > 0) {
        return images[images.length-1]
    } else {
        return "";
    }
}

export const getBase64Background = (props:any) => {
    const {
        rotate = -20,
        height = 75,
        width = 85,
        text = `湖北省药检院数字标本馆`,
        fontSize = '14px',
        lineWidth = 2,
        fontFamily = 'microsoft yahei',
        strokeStyle = 'rgba(255, 255, 255, .15)',
        fillStyle = 'rgba(0, 0, 0, 0.15)',
        position = { x: 30, y: 30 },
    } = props;
    const image = new Image();
    image.crossOrigin = 'Anonymous';
    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d');
    canvas.width = width;
    canvas.height = height;
    if (context) {
        context.font = `${fontSize} ${fontFamily}`;
        context.lineWidth = lineWidth;
        context.rotate(rotate * Math.PI / 180);
        context.strokeStyle = strokeStyle;
        context.fillStyle = fillStyle;
        context.textAlign = 'center';
        context.textBaseline = 'hanging';
        context.strokeText(text, position.x, position.y);
        context.fillText(text, position.x, position.y);
    }
    return canvas.toDataURL('image/png');
};

export const operationPicture = (imageUrl:string) => {
    const image = new Image();
    image.setAttribute("crossOrigin", "anonymous");// 解决跨域
    image.onload = () => {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        if (context){
            context.textAlign = "left";
            context.textBaseline = "bottom";
            context.font = "16px Microsoft Yahei";
            context.fillStyle = '#000';
            context.drawImage(image, 0, 0, image.width, image.height);
            context.rotate(Math.PI*16/180)
            context.fillText("湖北省药检院数字标本馆",50, 50)
            // const __wm = document.querySelector('.__wm');//选择器
            // const watermarkDiv = __wm || document.createElement("div");
            // const styleStr = `
            //     position:absolute;
            //     top:0px;
            //     left:0px;
            //     width:100%;
            //     height:100%;
            //     z-index:${1000};
            //     pointer-events:none;
            //     background-repeat:repeat;
            //     background-image:url('${url}')`;
            //
            // watermarkDiv.setAttribute('style', styleStr);
            // watermarkDiv.classList.add('__wm'); // 为元素添加“__wm”类名
            //
            // document.body.style.position = 'relative';
            // if (!__wm) {
            //     document.body.appendChild(watermarkDiv); // 添加元素
            // }
            const url = canvas.toDataURL("image/png", 0.7);
            console.log("dtl----", url);
            return url;
        }
    };
    image.src = imageUrl;
}


export const downLoadImageByUrl = (imageUrl:string, imageName:string) => {
    const image = new Image();
    image.setAttribute("crossOrigin", "anonymous");// 解决跨域
    image.src = imageUrl;
    image.onload = () => {
        const canvasLink = document.createElement("canvas");
        canvasLink.width = image.width;
        canvasLink.height = image.height;
        let context = canvasLink.getContext("2d");
        context?.drawImage(image, 0, 0, image.width, image.height)
        const url = canvasLink.toDataURL("image/png")
        const alink = document.createElement("a");
        alink.download = imageName;
        alink.href = url;
        alink.click();
    }
}